module.exports = __webpack_public_path__ + "static/media/absensi_ekskul.41d3d0b7.png";